import { useEffect, useState, useRef } from 'react';
import { IProjectConfig } from '@/types';
import { luca_ask_project_select_info } from '@/apis/qa';
import { getQaStore } from '@/store/qa';

export const useQueryProjects = (lucaId?: number) => {
    const [projects, setProjects] = useState<IProjectConfig[]>(getQaStore()?.getProjects() || []);
    const [loadStatus, setLoadStatus] = useState<boolean | 'no_data'>(projects.length ? false : true);

    const initProjects = async (lucaId: number) => {
        setLoadStatus(true);
        const { result } = await luca_ask_project_select_info({ lucaId });
        if (result?.projects?.length) {
            setLoadStatus(false);
            setProjects(result.projects);
            getQaStore()?.addProjects(result.projects);
        } else {
            setLoadStatus('no_data');
        }
    };

    useEffect(() => {
        if (!lucaId) return;
        if (!projects.length) {
            initProjects(lucaId);
        }
    }, [lucaId]);

    return { projects, loadStatus };
};

export const queryProjects = async (lucaId?: number) => {
    const list = getQaStore()?.getProjects();
    if (list?.length) return list;
    const { result } = await luca_ask_project_select_info({ lucaId: lucaId! });
    getQaStore()?.addProjects(result.projects || []);
    return result.projects || [];
};
